import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/home/index'
import error404 from '@/components/error404'
import error500 from '@/components/error500'

Vue.use(Router)


export const constantRoutes = [
  {
    path: '/:slug',
    name: 'Home',
    component: Home
  },
  {
    path: '/redirect',
    hidden: true,
    children: [{
      path: '/redirect/:path*',
      component: () => import('@/components/redirect/index')
    },
    {
      path: '/error404',
      name: 'error404',
      hidden: true,
      component: error404,
    },
    {
      path: '/error500',
      name: 'error500',
      hidden: true,

      component: error500,
    },
    {
      path: "*",
      redirect: "/error404",
      hidden: true
    },
  ]
  },
];

// export default new Router({
//   routes: [
   
    
//   ]
// })

const createRouter = () =>
  new Router({
    mode: 'history', // require service support
    scrollBehavior: () => ({
      y: 0
    }),
    routes: constantRoutes,
    linkActiveClass: "active",
  });


const router = createRouter();

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: {
    id: process.env.VUE_APP_GANALYTICS,
  },
}, router);

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// export default router;
export default router


// WEBPACK FOOTER //
// ./src/router/index.js